module.exports = __webpack_public_path__ + "3dc41baafc3d38c54a147e0e5fd0a5c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/0/Assets/pyramid.png
// module id = 1317
// module chunks = 0